import { getRateReqMapper } from "../mappers/rating/getRatesRequestMapper";
import shipvistaAPI from "./shipvistaAPI";

const objectMapper = require("object-mapper");

export const getFreightRateGuest = (rateRequestPre: any) => {
  const rateRequest = objectMapper(rateRequestPre, getRateReqMapper);
  if (
    rateRequest.lineItems.find((item: any) =>
      item?.PackagingType?.includes("UPS")
    )
  ) {
    rateRequest.ShippingCarriers = ["UPS"];
  }

  return shipvistaAPI.post(`/Rate/GetFreightRateGuest`, rateRequest);
};

// LTLService
export const getLTLServiceOptionsService = (carriersList: string[]) => {
  return shipvistaAPI.post(
    `/ShippingServices/GetFreightServiceOptions`,
    carriersList
  );
};

export const recordFreightService = (rateRequestPre: any) => {
  const rateRequest = objectMapper(rateRequestPre, getRateReqMapper);

  return shipvistaAPI.post(`/Rate/RecordFreightRequest`, rateRequest);
};
